import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { IncomePage } from "web_myplann/Finances/Pages/IncomePage";
import { IncomeV2Page } from "web_myplann/Finances/Pages/IncomeV2Page";

export const IncomePageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <IncomeV2Page /> : <IncomePage />;
};
